/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 添加场次开票提醒
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  isRemind: string,
  showId: number,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.RemindDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/project/show/${showId}/${isRemind}/remind`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
